import { apiFetch } from './api';

export interface AuthUser {
  id: string;
  email: string;
  created_at: number;
}

export interface AuthResponse {
  user: AuthUser;
}

export function loginRequest(email: string, password: string): Promise<AuthResponse> {
  return apiFetch<AuthResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function registerRequest(email: string, password: string): Promise<AuthResponse> {
  return apiFetch<AuthResponse>('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function logoutRequest(): Promise<{ success: boolean }> {
  return apiFetch<{ success: boolean }>('/api/auth/logout', { method: 'POST' });
}

export function currentUserRequest(): Promise<AuthResponse> {
  return apiFetch<AuthResponse>('/api/auth/me');
}
